import AppContext from "./AppContext";
import { Provider } from "react-redux";
import store, { persistor } from "./store";
import AppRoute from "./navigation/AppRoute";
import routesConfig from "./navigation/RoutesConfig";
import { ThemeProvider } from "@mui/material";
import { appTheme } from "./utils/theme";
import AppMessageBar from "./components/AppMessageBar";
import Blocked from "./components/Blocked";
import PerformanceStatusBar from "./components/PerformanceStatusBar";
import { StatusBar, Style } from "@capacitor/status-bar";
import React, { useEffect } from "react";
import { Capacitor } from "@capacitor/core";
import { PersistGate } from "redux-persist/integration/react";
import { appVersionCheck, retrieveLanguagePreference } from "./utils";
import config from "./utils/config";
import { GoogleOAuthProvider } from '@react-oauth/google';
import { useTranslation } from "react-i18next";
import EventLogger from "./utils/eventLogger";
const eventLogger = new EventLogger();
function App() {
  const { i18n } = useTranslation();
  const handleLocaleChange = () => {
    i18n.changeLanguage(retrieveLanguagePreference());
  }

  useEffect(() => {
    // check for status bar
    if (Capacitor.isPluginAvailable("StatusBar")) {
      StatusBar.setStyle({ style: Style.Dark });
      StatusBar.setBackgroundColor({ color: "#003B6A" });
    }
    eventLogger.init();
    appVersionCheck();
    handleLocaleChange();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <AppContext.Provider value={routesConfig}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ThemeProvider theme={appTheme}>
            <React.Suspense fallback={<div>Loading...</div>}>
              <GoogleOAuthProvider clientId={config.GOOGLE_CLIENTID}>
                <PerformanceStatusBar />
                <Blocked />
                <AppMessageBar />
                <AppRoute routes={routesConfig} />
                {/* <Offline><Box sx={sx}><Typography>You are currently offline!</Typography></Box></Offline> */}
              </GoogleOAuthProvider>
            </React.Suspense>
          </ThemeProvider>
        </PersistGate>
      </Provider>
    </AppContext.Provider>
  );
}

// const sx = {
//   width: '100vw',
//   textAlign: 'center',
//   backgroundColor: '#003B6A',
//   color: '#FFFFFF',
//   paddingTop: 1,
//   paddingBottom: 1,
//   position: "absolute",
//   zIndex: 100,
//   display: 'block'
// }
export default App;
